/*
* Pipeline Theme — Custom JS
* Organic Home (stonemen-in)
*/

/* ── Wishlist button relocation (single instance) ── */
(function(){
  if(window.__wlhProductMoveFromCustomInit)return;
  window.__wlhProductMoveFromCustomInit=!0;

  function ensureMovedWishlistStyles(){
    if(document.getElementById('wlh-product-inline-mover-styles')) return;
    var style=document.createElement('style');
    style.id='wlh-product-inline-mover-styles';
    style.textContent=[
      '.product__block__text--wishlist-runtime-row{display:block !important;width:100% !important;max-width:none !important;}',
      '.product__block__text--wishlist-runtime-row .product__block__wishlist-row{display:flex !important;align-items:center !important;justify-content:space-between !important;gap:16px !important;width:100% !important;max-width:none !important;}',
      '.product__block__text--wishlist-runtime-row .product__block__wishlist-row-content{display:block !important;flex:1 1 auto !important;min-width:0 !important;}',
      '.product__block__text--wishlist-runtime-row .product__block__wishlist-row-actions{display:flex !important;align-items:center !important;justify-content:flex-end !important;flex:0 0 auto !important;line-height:1 !important;margin-left:auto !important;padding-left:12px !important;}',
      '.product__block__text--wishlist-runtime-row .wishlisthero-product-page-button-container{display:flex !important;align-items:center !important;justify-content:flex-end !important;margin:0 !important;padding:0 !important;position:static !important;width:auto !important;}',
      '.product__block__text--wishlist-runtime-row .wishlisthero-product-page-button-container button{display:inline-flex !important;align-items:center !important;justify-content:center !important;min-width:24px !important;width:24px !important;height:24px !important;padding:0 !important;border:0 !important;background:transparent !important;box-shadow:none !important;color:transparent !important;font-size:0 !important;line-height:0 !important;overflow:hidden !important;}',
      '.product__block__text--wishlist-runtime-row .wishlisthero-product-page-button-container button svg,.product__block__text--wishlist-runtime-row .wishlisthero-product-page-button-container button img{display:block !important;width:22px !important;height:22px !important;}',
      '.product__submit .wishlisthero-product-page-button-container{display:none !important;}'
    ].join('');
    document.head.appendChild(style);
  }

  function moveWishlistButton(root){
    var scope=root&&root.querySelectorAll?root:document;
    scope.querySelectorAll('.product__inner[data-product-form-wrapper]').forEach(function(productRoot){
      var textBlock=productRoot.querySelector('.product__block__text');
      var buttonContainer=productRoot.querySelector('.wishlisthero-product-page-button-container');
      if(!textBlock||!buttonContainer) return;

      if(!textBlock.classList.contains('product__block__text--wishlist-runtime-row')){
        var content=document.createElement('div');
        content.className='product__block__wishlist-row-content';
        while(textBlock.firstChild){
          content.appendChild(textBlock.firstChild);
        }
        var row=document.createElement('div');
        row.className='product__block__wishlist-row';
        row.appendChild(content);
        var actions=document.createElement('div');
        actions.className='product__block__wishlist-row-actions';
        row.appendChild(actions);
        textBlock.appendChild(row);
        textBlock.classList.add('product__block__text--wishlist-runtime-row');
      }

      var actionsHolder=textBlock.querySelector('.product__block__wishlist-row-actions');
      var contentHolder=textBlock.querySelector('.product__block__wishlist-row-content');
      if(!actionsHolder && contentHolder){
        var rebuiltRow=document.createElement('div');
        rebuiltRow.className='product__block__wishlist-row';
        var rebuiltActions=document.createElement('div');
        rebuiltActions.className='product__block__wishlist-row-actions';
        textBlock.appendChild(rebuiltRow);
        rebuiltRow.appendChild(contentHolder);
        rebuiltRow.appendChild(rebuiltActions);
        actionsHolder=rebuiltActions;
      }

      if(actionsHolder && !actionsHolder.contains(buttonContainer)){
        actionsHolder.appendChild(buttonContainer);
      }
    });
  }

  function boot(root){
    ensureMovedWishlistStyles();
    moveWishlistButton(root);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){boot(document);});
  } else {
    boot(document);
  }

  var debounceTimer;
  var observer=new MutationObserver(function(){
    clearTimeout(debounceTimer);
    debounceTimer=setTimeout(function(){boot(document);},150);
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});

  document.addEventListener('shopify:section:load',function(event){boot(event.target||document);});
  document.addEventListener('theme:variant:change',function(event){boot(event.target||document);});
})();

/* ── Cart drawer on add-to-cart ── */
(function(){
  if (window.__ohCartDrawerFromAddToCartInit) return;
  window.__ohCartDrawerFromAddToCartInit = true;

  var lastCartChangeAt = 0;

  function markCartChanged() {
    lastCartChangeAt = Date.now();
  }

  function openCartDrawerFromProductAdd() {
    var popdown = document.querySelector("[data-product-add-popdown-wrapper]");
    if (popdown) {
      popdown.classList.remove("is-visible");
      popdown.innerHTML = "";
    }
    var cartDrawer = document.querySelector("[data-drawer=\"drawer-cart\"]");
    if (cartDrawer) {
      cartDrawer.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: false }));
    }
  }

  function openAfterCartRefresh() {
    var opened = false;
    var timeoutId = null;

    function finish() {
      if (opened) return;
      opened = true;
      document.removeEventListener("theme:cart:change", onCartChange);
      if (timeoutId) clearTimeout(timeoutId);
      requestAnimationFrame(openCartDrawerFromProductAdd);
    }

    function onCartChange() {
      markCartChanged();
      finish();
    }

    if (Date.now() - lastCartChangeAt < 1500) {
      finish();
      return;
    }

    document.addEventListener("theme:cart:change", onCartChange);
    timeoutId = setTimeout(finish, 1500);
  }

  if (!document.getElementById("oh-hide-product-add-popdown")) {
    var style = document.createElement("style");
    style.id = "oh-hide-product-add-popdown";
    style.textContent = ".product-add-popdown{display:none !important;pointer-events:none !important;}";
    document.head.appendChild(style);
  }

  document.addEventListener("theme:cart:change", markCartChanged);

  document.addEventListener("theme:cart:popdown", function(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    openAfterCartRefresh();
  }, true);
})();

/* ── Mobile WhatsApp floating button ── */
(function(){
  if (window.__ohMobileFooterWhatsappFixInit) return;
  window.__ohMobileFooterWhatsappFixInit = true;

  function ensureStyles() {
    if (document.getElementById("oh-mobile-footer-whatsapp-fix")) return;
    var style = document.createElement("style");
    style.id = "oh-mobile-footer-whatsapp-fix";
    style.textContent = "@media screen and (max-width: 767px){.sticky_footer_mob .whatsappicon-lists{display:none !important;}.sticky_footer_mob .fixed-footer-bottom{display:flex !important;align-items:flex-end !important;justify-content:space-between !important;padding:5px 12px !important;}.sticky_footer_mob .fixed-footer-bottom .footer-icon-lists{flex:1 1 25% !important;max-width:25% !important;display:flex !important;flex-direction:column !important;align-items:center !important;justify-content:center !important;min-width:0 !important;}.sticky_footer_mob .fixed-footer-bottom .footer-icon-lists a{display:flex !important;align-items:center !important;justify-content:center !important;min-height:20px !important;}.sticky_footer_mob .fixed-footer-bottom .footer-icon-lists p{margin:4px 0 0 !important;text-align:center !important;}.sticky-footer-whatsapp-float-fallback{position:fixed !important;right:16px !important;bottom:72px !important;z-index:10 !important;width:52px !important;height:52px !important;border-radius:50% !important;background:#25D366 !important;display:flex !important;align-items:center !important;justify-content:center !important;box-shadow:0 8px 24px rgba(0,0,0,.22) !important;}.sticky-footer-whatsapp-float-fallback svg{width:28px !important;height:28px !important;display:block !important;}}";
    document.head.appendChild(style);
  }

  function ensureFloatingButton() {
    if (window.innerWidth > 767) return;
    if (document.querySelector(".sticky-footer-whatsapp-float") || document.querySelector(".sticky-footer-whatsapp-float-fallback")) return;
    var link = document.createElement("a");
    link.className = "sticky-footer-whatsapp-float-fallback";
    link.href = "https://wa.me/919520837111";
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.setAttribute("aria-label", "Chat on WhatsApp");
    link.innerHTML = '<svg viewBox="0 0 32 32" aria-hidden="true" focusable="false"><path fill="#FFFFFF" d="M19.11 17.41c-.29-.15-1.69-.83-1.95-.92-.26-.1-.45-.15-.64.15-.19.29-.73.92-.9 1.1-.17.19-.33.22-.62.07-.29-.15-1.21-.45-2.31-1.43-.85-.76-1.42-1.69-1.58-1.98-.17-.29-.02-.45.13-.6.13-.13.29-.33.43-.5.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.5-.07-.15-.64-1.54-.88-2.11-.23-.56-.47-.48-.64-.49h-.55c-.19 0-.5.07-.76.36-.26.29-1 1-.99 2.44 0 1.44 1.04 2.83 1.19 3.02.14.19 2.04 3.12 5.04 4.25.71.31 1.27.5 1.7.64.71.23 1.35.19 1.86.12.57-.08 1.69-.69 1.93-1.36.24-.67.24-1.24.17-1.36-.07-.12-.26-.19-.55-.33Z"></path><path fill="#FFFFFF" d="M16.01 4.8c-6.17 0-11.18 5.01-11.18 11.18 0 1.97.51 3.89 1.48 5.58L4.7 27.2l5.79-1.52c1.6.87 3.39 1.33 5.22 1.33h.01c6.17 0 11.18-5.02 11.18-11.19 0-2.99-1.16-5.8-3.28-7.91A11.11 11.11 0 0 0 16.01 4.8Zm0 20.32h-.01a9.03 9.03 0 0 1-4.6-1.26l-.33-.19-3.44.9.92-3.36-.22-.35a9 9 0 0 1-1.39-4.82c0-4.98 4.05-9.03 9.04-9.03 2.41 0 4.67.94 6.37 2.64a8.97 8.97 0 0 1 2.64 6.38c0 4.99-4.06 9.04-9.05 9.04Z"></path></svg>';
    document.body.appendChild(link);
  }

  function boot() {
    ensureStyles();
    ensureFloatingButton();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("theme:resize", boot);
})();


// (function () {
//   const MIN_ZOOM_SCALE = 0.001;

//   function limitProductImageZoom() {
//     const images = document.querySelectorAll(
//       '[data-zoom-wrapper] img, [data-product-image] img'
//     );

//     images.forEach(function (img) {
//       img.style.transformOrigin = 'center center';

//       const observer = new MutationObserver(function () {
//         const transform = img.style.transform;

//         if (!transform) return;

//         const match = transform.match(/scale\(([\d.]+)\)/);

//         if (match) {
//           const scale = parseFloat(match[1]);

//           if (scale < MIN_ZOOM_SCALE) {
//             img.style.transform = transform.replace(
//               /scale\([\d.]+\)/,
//               'scale(' + MIN_ZOOM_SCALE + ')'
//             );
//           }
//         }
//       });

//       observer.observe(img, {
//         attributes: true,
//         attributeFilter: ['style']
//       });
//     });
//   }

//   document.addEventListener('DOMContentLoaded', limitProductImageZoom);
// })();